var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import React from 'react';
import { Dropdown } from 'react-bootstrap';
import iconAppSwitcher from './app-switcher.svg';
var DropdownItemList = function (_a) {
  var items = _a.items;
  if (typeof items === 'undefined') return null;
  var dropdownItems = items.map(function (item, index) {
    return React.createElement(DropdownItem, {
      id: "app-switch-item-" + index,
      key: "app-switch-item-" + index,
      url: item.url,
      logo: item.logo,
      alt: item.alt,
      name: item.name,
      isExternal: item.isExternal
    });
  });
  return React.createElement(React.Fragment, null, dropdownItems);
};
var DropdownItem = function (_a) {
  var id = _a.id,
    url = _a.url,
    logo = _a.logo,
    alt = _a.alt,
    name = _a.name,
    isExternal = _a.isExternal;
  return React.createElement(Dropdown.Item, {
    key: 'key-dropdown-apps' + id,
    className: 'p-0',
    as: 'li'
  }, React.createElement("a", {
    href: url,
    className: 'dropdown-link link-unstyled',
    target: '_blank'
  }, React.createElement("div", {
    className: 'd-flex align-items-center px-3 py-2 border-bottom'
  }, React.createElement("img", {
    className: 'mr-3',
    width: 21,
    height: 21,
    src: logo,
    alt: alt
  }), React.createElement("strong", null, name), isExternal && React.createElement("small", null, React.createElement("i", {
    className: 'fas fa-external-link-alt ml-2'
  })))));
};
var HOAppSwitcher = /** @class */function (_super) {
  __extends(HOAppSwitcher, _super);
  function HOAppSwitcher() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  HOAppSwitcher.prototype.render = function () {
    var _a = this.props,
      items = _a.items,
      alignRight = _a.alignRight;
    return React.createElement(Dropdown, {
      className: 'dropdown'
    }, React.createElement(Dropdown.Toggle, {
      id: 'dropdown-apps',
      // @ts-ignore
      variant: 'white',
      className: 'btn-sm d-flex align-items-center',
      "data-toggle": 'dropdown',
      "data-display": 'static'
    }, React.createElement("img", {
      src: iconAppSwitcher,
      width: 21,
      height: 21,
      alt: 'App Switcher'
    })), React.createElement(Dropdown.Menu, {
      as: 'ul',
      className: 'mt-1 p-0 border-0 rounded-0 shadow',
      // @ts-ignore (bootstrap only accepts true | undefined)
      alignRight: alignRight
    }, React.createElement(DropdownItemList, {
      items: items
    })));
  };
  return HOAppSwitcher;
}(React.Component);
export { HOAppSwitcher };